import helpUrls from '../../../../config/feature_help_urls.yml';

export function getHelpUrlForFeature(featureName) {
  const target = helpUrls[featureName];
  if (!target) return undefined;
  const { hostURL, helpCenterURL } = window.chatwootConfig || {};
  const base = helpCenterURL || hostURL || window.location.origin;
  const { pathname, search, hash } = new URL(target);
  return `${base}${pathname}${search}${hash}`;
}
